(function () {
  'use strict';

  var selector = '.kk-home-hero--viewport-frame';
  var frame = 0;

  function syncHero(hero) {
    var pageTop = hero.getBoundingClientRect().top + window.pageYOffset;
    hero.style.setProperty('--kk-hh-page-offset', Math.max(0, Math.round(pageTop)) + 'px');
  }

  function syncAll() {
    frame = 0;
    document.querySelectorAll(selector).forEach(syncHero);
  }

  function scheduleSync() {
    if (frame) return;
    frame = window.requestAnimationFrame(syncAll);
  }

  function observeHeader() {
    if (!('ResizeObserver' in window)) return;

    var observer = new ResizeObserver(scheduleSync);
    document.querySelectorAll('[class*="shopify-section-group-header-group"]').forEach(function (headerSection) {
      observer.observe(headerSection);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncAll();
      observeHeader();
    }, { once: true });
  } else {
    syncAll();
    observeHeader();
  }

  window.addEventListener('load', scheduleSync, { once: true });
  window.addEventListener('resize', scheduleSync, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync, { passive: true });
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);
})();
